import { render, staticRenderFns } from "./chapterEdit.vue?vue&type=template&id=767d6328&scoped=true"
import script from "./chapterEdit.vue?vue&type=script&lang=js"
export * from "./chapterEdit.vue?vue&type=script&lang=js"
import style0 from "./chapterEdit.vue?vue&type=style&index=0&id=767d6328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d6328",
  null
  
)

export default component.exports